export default "__VITE_ASSET__DKwo$DPd__"